import { Box, styled } from "@mui/material";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";

export const StatusBar = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "8px 16px",
  backgroundColor: "white",
});

export const Header = styled(Box)({
  display: "flex",
  alignItems: "center",
  padding: "8px 4px",
  backgroundColor: "white",
  borderBottom: "1px solid #e0e0e0",
});

export const SectionSpacer = () => <Box sx={{ bgcolor: "#f5f5f5", height: 8 }} />;

export const TriangleDown = () => (
  <Box
    sx={{
      width: 0,
      height: 0,
      borderLeft: "8px solid transparent",
      borderRight: "8px solid transparent",
      borderTop: "10px solid #666",
    }}
  />
);

export const ImageReceiptIcon = () => (
  <Box
    sx={{
      position: "absolute",
      top: 8,
      right: 8,
      width: 44,
      height: 44,
      bgcolor: "#ffebee",
      border: "2px solid #f44336",
      borderRadius: 1,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <ReceiptLongIcon sx={{ color: "#f44336", fontSize: 24 }} />
  </Box>
);

export const CoinIcon = () => (
  <Box
    sx={{
      width: 24,
      height: 24,
      borderRadius: "50%",
      bgcolor: "#ff9800",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "white",
      fontSize: 12,
      fontWeight: "bold",
    }}
  >
    P
  </Box>
);

export const BarcodeIcon = () => (
  <Box sx={{ display: "flex", alignItems: "center", gap: "3px" }}>
    {[3, 2, 4, 2, 3, 2, 4].map((w, i) => (
      <Box key={i} sx={{ width: w, height: 14, bgcolor: "#666" }} />
    ))}
  </Box>
);
